import React from 'react';
import ReactDOM from 'react-dom';
import PlayerCompareWidget from './components/playerCompareWidget.jsx';
import { createStore } from 'redux';
import 'react-select2-wrapper/css/select2.css';
import RoundGamesWidget from './components/roundGamesWidget.jsx';
import LiveGamesWidget from './components/liveGamesWidget.jsx';
import LeagueTableWidget from './components/leagueTableWidget.jsx';
import StatsWidget from './components/statsWidget.jsx';
import StatsPageWidget from './components/statsPageWidget.jsx';
import Modal from 'react-modal';


let lastPartOfUrl = location.href.split('/').filter(e => e).pop(); // filter the last trailing slash and get the team name
let teamFilter = {};
let teamName = currentSitePage == 'team' || currentSitePage == 'stats' ? lastPartOfUrl : null;

let teamId = teamName;
if(isNaN(teamName)) {
    teamId = getTeamFromName(teamName);
}

if(isset(currentTeamId)) {
    teamId = currentTeamId;
}
//let currentPlayerId = (currentSitePage == 'player') ? lastPartOfUrl : currentPlayerId;
let currentLeague = 902;

const customStyles = {
    overlay: {
        backgroundColor: 'transparent',
        position: "fixed",
        top: 0,
        margin: "auto",
        bottom: "150px"
    },
    content : {
        background: "white",
        maxHeight: "570px",
        width: "350px",
        margin: "auto",
        marginTop: "150px",
        overflow: "auto"
    }
};

if( isset(teamId)) {
    teamFilter.teamId = teamId;
}

if(!isset(currentGamesRounds)) {
    currentGamesRounds = currentRound[902]['RegularSeason'];
}

function getFromBamboo(callback, apiEndpoint, filter, sort, returnZeros, prefix, expand, disableDefaultFilter, useCache) {
    if(typeof prefix == 'undefined') {
        prefix = 'football'
    }

    if(typeof prefix == 'undefined') {
        useCache = true;
    }

    var url = "https://" + bambooCdnApiBaseUrl+ "/api/" + prefix + "/" + apiEndpoint + "?format=json&iid=573881b7181f46ae4c8b4567";

    if(filter) {
        url = url + "&filter=" + JSON.stringify(filter);
    }

    if(sort) {
        url = url + "&sort=" + JSON.stringify(sort);
    }
    if(returnZeros) {
        url = url + "&returnZeros=" + returnZeros;
    }

    if(expand) {
        url = url + "&expand=" + JSON.stringify(expand);
    }

    if(disableDefaultFilter) {
        url = url + "&disableDefaultFilter=" + disableDefaultFilter;
    }

    if(!useCache) {
        url = url + "&useCache=false&ts=" + Math.round(Date.now() / 60 / 1000);
    }

    jQuery.get( url , function(data) {
        callback(data);
    });
}

/**
 * Sets the players callback for API call.
 */
function setPlayers(data ) {
    store.dispatch({type: "SET_PLAYERS", val: data});
    dataIsReady();
}

/**
 * Sets the players callback for API call.
 */
function setTeams(data ) {
    for (let teamId in data.data) {
        let team = data.data[teamId];

        //league Stats
        for (let teamLeagueStatsId in team.stats) {
            let teamLeagueStats = team.stats[teamLeagueStatsId];

            //Season Stats
            for (let teamStatsId in teamLeagueStats) {
                let teamStats = teamLeagueStats[teamStatsId];

                //Round Stats
                for (let teamStatsRoundId in teamStats) {
                    let teamStatsRound = teamStats[teamStatsRoundId];

                    if (typeof teamStatsRound['Goal'] != 'undefined' && typeof teamStatsRound['AttemptonGoal'] != 'undefined') {
                        teamStatsRound['GoalForAttemptonGoal'] = teamStatsRound['Goal'] > 0 ?
                            Math.round(teamStatsRound['AttemptonGoal'] / teamStatsRound['Goal']) : 0;
                    }
                }
            }
        }
    }

    store.dispatch({type: "SET_TEAMS", val: data});

    var lastPart = location.href.substr(location.href.lastIndexOf('/') + 1);
    if(isNumeric(lastPart)) {
        store.dispatch({type: "SELECT_TYPE", val: "team"});
        store.dispatch({type: "SELECT_TEAM", val: lastPart});
    }
    dataIsReady();
}

function isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Sets the players callback for API call.
 */
function setGames(data ) {
    store.dispatch({type: "SET_GAMES", val: data});
}

/**
 * Sets the players callback for API call.
 */
function setRounds(data ) {
    store.dispatch({type: "SET_ROUNDS", val: data});
}

function setRoundsStats(data ) {
    let res = { data: []};
    let size = 0;
    let isPlayoff = false;

    //Handle regular season
    for(let key in data.data) {
        if(data.data[key].stage == 'RegularSeason') {
            var roundId = data.data[key].id;
            res.data[roundId - 1] = data.data[key];
            size++;
        }

        //TODO: check this for season last round 26
        if(data.data[key].stage == 'RegularSeason' && data.data[key].currentRound && key == 26) {
            isPlayoff = true
        }
    }


    if(isPlayoff) {
        for(let key in data.data) {
            // if(data.data[key].stage == 'ChampionshipRound' ) {
            //     var roundId = data.data[key].id;
            //
            //     res.data[parseInt(roundId) + 25] = data.data[key];
            //     res.data[parseInt(roundId) + 25].name = parseInt(roundId) + 26;
            //     res.data[parseInt(roundId) + 25].id = parseInt(roundId) + 26;
            // }
        }
    }

    store.dispatch({type: "SET_ROUNDS", val: res});
}

currentSeason = "26/27";

if(typeof regularSeasonEnd == 'undefined') {
    regularSeasonEnd = false;
}

if(typeof regularSeasonEndLeumit == 'undefined') {
    regularSeasonEndLeumit = false;
}

if(typeof disclaimer == 'undefined') {
    disclaimer = "";
}

if(typeof leumitDisclaimer == 'undefined') {
    leumitDisclaimer = "";
}

const reduce = (state = {
    players: {},
    teams: {},
    stats: {},
    player1Id: currentPlayerId,
    player2Id: comparePlayerId,
    team1Id: currentTeamId,
    team2Id: compareTeamId,
    compareType: compareType,
    rounds: {},
    roundsRegular: {},
    roundsUpper: {},
    roundsLower: {},
    regularSeasonEnd: regularSeasonEnd,
    regularSeasonEndLeumit: regularSeasonEndLeumit,
    currentLiveScoreRound: parseInt(currentGamesRounds),
    currentLiveScoreRoundUpper: parseInt(currentGamesRoundUpper),
    currentLiveScoreRoundLower: parseInt(currentGamesRoundLower),
    liveStage: regularSeasonEnd ? "playoff" : "regularSeason",
    currentGamesRound: parseInt(currentGamesRounds),
    currentGamesRoundUpper: parseInt(currentGamesRoundUpper),
    currentGamesRoundLower: parseInt(currentGamesRoundLower),
    currentGamesStage: regularSeasonEnd ? "playoff" : "regularSeason",
    selectedStage: null,
    statsFilter: {},
    // statsApiFilter: {'tournamentId': parseInt(statsLeague), 'seasonName': currentSeason, 'round': parseInt(selectedRound)}, //TODO: change when season starts
    statsApiFilter: {'tournamentId': parseInt(statsLeague), 'seasonName': "26/27", 'round': parseInt(selectedRound)}, //TODO: change when we want hard coded stats on homepage - before season starts
    standingsApiFilter: {"$or":[{"tournamentId": 902},{"tournamentId": 719}], 'seasonName': "26/27"},
    selectedRound: 0,
    selectedLeague: statsLeague,
    selectedSeason: "26/27",
    selectedType: "player",
    showMoreCount: 1,
    currentGameId: null,
    categories: categories,
    gotFullStats: false,
    loading: true,
    currentLeague: parseInt(statsLeague),
    currentSlideIndex: null,
    currentUpperSlideIndex: null,
    currentLowerSlideIndex: null,
    modal: {
        isOpen: false,
        selectedCategory: categories.length ? categories[0] : {}
    },
    disclaimer: disclaimer,
    leumitDisclaimer: leumitDisclaimer
}, action ) => {
    let newState = Object.assign({}, state);

    console.log("action type: " + action.type + "value :" + action.val);
    switch (action.type) {
        case "CHANGE_PLAYER":
            if(action.widgettype == 'player') {
                if(action.side == 1) {
                    newState.player1Id = action.playerId;
                } else {
                    newState.player2Id = action.playerId;
                }
            } else {
                if(action.side == 1) {
                    newState.team1Id = action.playerId;
                } else {
                    newState.team2Id = action.playerId;
                }
            }
            break;
        case "NEXT_ROUND":
            if(state.currentGamesStage == 'playoff') {

                if (state.currentGamesRoundLower < 7 && action.val) {
                    newState.currentGamesRoundLower++
                }

                if (state.currentGamesRoundUpper < 10 && !action.val) {
                    newState.currentGamesRoundUpper++
                }
            }  else {
                if (state.currentGamesRound < 26) {
                    newState.currentGamesRound++;
                }
            }
            break;
        case "PREVIOUS_ROUND":
            if(state.currentGamesStage == 'playoff') {
                if (state.currentGamesRoundLower > 1 && action.val) {
                    newState.currentGamesRoundLower--
                }

                if (state.currentGamesRoundUpper > 1 && !action.val) {
                    newState.currentGamesRoundUpper--
                }
            }  else {
                if (state.currentGamesRound > 1) {
                    newState.currentGamesRound--;
                }
            }
            break;
        case "NEXT_ROUND_LIVE":
            if(state.liveStage == 'playoff') {

                if (state.currentLiveScoreRound < 7 && action.val) {
                    newState.currentLiveScoreRound++
                }

                if (state.currentLiveScoreRound < 10 && !action.val) {
                    newState.currentLiveScoreRound++
                }
            }  else {
                if (state.currentLiveScoreRound < 26) {
                    newState.currentLiveScoreRound++;
                }
            }
            break;
        case "PREVIOUS_ROUND_LIVE":
            if(state.liveStage == 'playoff') {
                if (state.currentLiveScoreRound > 1 && action.val) {
                    newState.currentLiveScoreRound--
                }

                if (state.currentLiveScoreRound > 1 && !action.val) {
                    newState.currentLiveScoreRound--
                }
            }  else {
                if (state.currentLiveScoreRound > 1) {
                    newState.currentLiveScoreRound--;
                }
            }
            break;
        case "SET_CURRENT_ROUND":
                console.log('current round update ',action.val);

                if(action.stage == 'regularSeason') {
                    newState.currentLiveScoreRound = action.val > 1 ? action.val : 1;
                } else if (action.stage == 'championshipRound' ) {
                    newState.currentLiveScoreRoundUpper = (action.val > 0) ? action.val : 0;
                } else {
                    newState.currentLiveScoreRoundLower = (action.val > 0) ? action.val : 0;
                }
            break;
        case ('SELECT_TEAM'):
            if(action.val == null) {
                delete newState.statsFilter.id; //Clear any player search we might have done.
                delete newState.statsFilter.teamId;
            } else {
                if(newState.selectedType == 'player') {
                    newState.statsFilter.teamId = action.val;
                    delete newState.statsFilter.id;
                } else {
                    newState.statsFilter.id = action.val;
                    delete newState.statsFilter.teamId;
                }
            }

            break;
        case ('SELECT_PLAYER'):
            newState.statsFilter = {};
            newState.categories = categories;
            newState.selectedType = 'player';

            if(action.val != null) {
                newState.statsFilter.id = action.val;
            } else {
                delete newState.statsFilter.id;
            }
            break;
        case ('SELECT_POSITION'):
            delete newState.statsFilter.id;
            newState.categories = categories;
            newState.selectedType = 'player';

            if(action.val) {
                newState.statsFilter.position = action.val;
                if(newState.statsFilter.position == 'goalie') {
                    newState.categories = goalieCategories;
                }
            } else {
                delete newState.statsFilter.position;
            }
            break;
        case ('SELECT_SEASON'):
            newState.selectedSeason = action.val;
            newState.statsApiFilter.seasonName = action.val;
            if(['16/17', '17/18', '18/19'].indexOf(action.val) >= 0) {
               newState.selectedLeague = 902; //Override league for switching to old seasons
               newState.statsApiFilter.tournamentId = 902;
            }

            delete newState.statsFilter.id; //Clear any player search we might have done, as we move between seasons
            delete newState.statsFilter.teamId;

            getFromBamboo(getStats, 'stats', newState.statsApiFilter, null, "false", 'football', statsExpand, true);

            break;
        case ('SELECT_LEAGUE'):
            newState.selectedLeague = action.val;
            newState.statsApiFilter.tournamentId = parseInt(action.val);

            getFromBamboo(getStats, 'stats', newState.statsApiFilter, null, "false", 'football', statsExpand, true);

            break;
        case ('SELECT_TYPE'):
            delete newState.statsFilter.id; //Remove player / team filters
            delete newState.statsFilter.teamId;
            delete newState.statsFilter.position;

            newState.selectedType = action.val;
            newState.categories = action.val == 'team' ? teamCategories : categories;
            break;
        case ('SELECT_ROUND'):
            newState.selectedRound = action.val;
            newState.statsApiFilter.round = parseInt(action.val);

            if(newState.selectedRound === 0 && (newState.selectedStage != 'RegularSeason' && newState.selectedStage != null)) {
                newState.selectedStage = null;
                if( typeof newState.statsApiFilter.stage !== 'undefined') {
                    delete newState.statsApiFilter.stage;
                    delete newState.statsFilter.stage;
                }
            }

            if(newState.selectedRound != 0 && newState.selectedStage == null) {
                //We choose round and don't have a stage, then we select main league as default
                newState.statsApiFilter.stage = 'RegularSeason';
                newState.selectedStage = "RegularSeason";
                newState.statsFilter.stage = 'RegularSeason';
            }

            getFromBamboo(getStats, 'stats', newState.statsApiFilter, null, "false", 'football', statsExpand, true);

            break;
        case ('SELECT_STAGE'):
            newState.selectedStage = action.val;
            newState.statsFilter.stage = action.val;

            if(newState.selectedStage === '' || newState.selectedStage == null ) { // default non selected
                //if stage is set we unset it
                if(typeof newState.statsApiFilter.stage != 'undefined') {
                    delete newState.statsApiFilter.stage;
                }
                newState.statsApiFilter.round = 0;
                newState.selectedRound = 0;
            } else { // Promotion\Championship\Relegation stage\RegularSeason
                newState.statsApiFilter.stage = action.val;
                newState.statsApiFilter.round = 1;
                newState.selectedRound = 1;
            }

            getFromBamboo(getStats, 'stats', newState.statsApiFilter, null, "false", 'football', statsExpand, true);
            break;
        case ('SHOW_MORE'):
            newState.showMoreCount = action.val;
            break;
        case "SET_PLAYERS":
            newState.players = action.val.data;
            newState.player1Id = currentPlayerId;
            newState.player2Id = comparePlayerId;
            break;
        case "SET_STATS":
            newState.stats = action.val.data;
            break;
        case "SET_STANDINGS":
            newState.standings = action.val.data;
            break;
        case ('SET_TEAMS'):
            newState.teams = action.val.data;
            break;
        case ('SET_GAMES'):
            newState.games = action.val.data;
            //Gets last key in object
            if(action.val.data.length > 0) {
                newState.currentGameId = action.val.data[Object.keys(action.val.data)[Object.keys(action.val.data).length - 1]].id;
            }
            break;
        case ('SET_ROUNDS'):
            newState.rounds = action.val.data;
            newState.roundsRegular = {};
            newState.roundsUpper = {};
            newState.roundsLower = {};

            if(typeof action != 'undefined' && typeof action.val != 'undefined' && typeof action.val.data != 'undefined') {
                action.val.data.forEach(function(value) {
                    if(value.stage == 'RegularSeason') {
                        newState.roundsRegular[value.id] = value;
                    } else if(value.stage == 'ChampionshipRound' ) {
                        newState.roundsUpper[value.id] = value;
                    } else if(value.stage == 'RelegationRound' ) {
                        newState.roundsLower[value.id] = value;
                    }
                });
            }

            break;
        case ('PREVIOUS_GAME'):
            newState.currentGameId = action.val;
            break;
        case ('NEXT_GAME'):
            newState.currentGameId = action.val;
            break;
        case("SHOW_ALL_STATS"):
            // newState.modal.isOpen = true;
            // newState.modal.selectedCategory = JSON.parse(action.val.currentTarget.dataset.cat);
            newState.categories[action.val.currentTarget.dataset.catindex].isOpen = true;
            break;
        case("CLOSE_MODAL"):
            newState.modal.isOpen = false;
            break;
        case("GOT_FULL_STATS"):
            newState.gotFullStats = action.val;
            break;
        case("STATS_LOADING"):
            newState.loading = action.val;
            break;
        case ('SET_CURRENT_LEAGUE'):
            newState.currentLeague = action.val;
            break;
        case ('SET_CURRENT_SLIDE_INDEX'):
            if(action.stage == 'regularSeason') {
                newState.currentSlideIndex = (action.val > 0) ? action.val : 0;
            } else if (action.stage == 'championshipRound' ) {
                newState.currentUpperSlideIndex = (action.val > 0) ? action.val : 0;
            } else {
                newState.currentLowerSlideIndex = (action.val > 0) ? action.val : 0;
            }


            break;
        default:
            return newState;
    }

    return newState;
};

const render = () => {

    if(!regularSeasonEnd) {
        //Render homepage games live games Season
        if(document.getElementById('live-games-react-lower')) {
            document.getElementById('live-games-react-lower').classList.add('hidden');
        }
        if(document.getElementById('live-games-react-upper')) {
            document.getElementById('live-games-react-upper').classList.add('hidden');
        }
        if(document.getElementById('live-games-react')) {
            ReactDOM.render(<LiveGamesWidget
                rounds={store.getState().roundsRegular}
                currentRound={store.getState().currentLiveScoreRound }
                gamesStage={store.getState().liveStage}
                currentSlideIndex={store.getState().currentSlideIndex}
            />, document.getElementById('live-games-react'));
        }
    } else {
        document.getElementById('live-games-react').classList.add('hidden');

        if(document.getElementById('live-games-react-upper')) {
            ReactDOM.render(<LiveGamesWidget
                rounds={store.getState().roundsUpper}
                currentRound={store.getState().currentLiveScoreRoundUpper }
                gamesStage={store.getState().liveStage}
                currentSlideIndex={store.getState().currentUpperSlideIndex}
                isRelegation={false}
            />, document.getElementById('live-games-react-upper'));
        }

        if(document.getElementById('live-games-react-lower')) {
            ReactDOM.render(<LiveGamesWidget
                rounds={store.getState().roundsLower}
                currentRound={store.getState().currentLiveScoreRoundLower }
                gamesStage={store.getState().liveStage}
                currentSlideIndex={store.getState().currentLowerSlideIndex}
                isRelegation={true}
            />, document.getElementById('live-games-react-lower'));
        }
    }

    //Render Homepage compare
    if(document.getElementById('league-table-react')) {
        //React league table widget
            ReactDOM.render(<LeagueTableWidget
                standings = { store.getState().standings}
                currentLeague={store.getState().currentLeague}
                gamesStage={store.getState().currentGamesStage}
                regularSeasonEnd={store.getState().regularSeasonEnd}
                regularSeasonEndLeumit={store.getState().regularSeasonEndLeumit}
                leumitDisclaimer={leumitDisclaimer}
                disclaimer={disclaimer}
            />, document.getElementById('league-table-react'));
    }

    //Render Homepage compare
    if(document.getElementById('league-table-react-leumit')) {
        //React league table widget
        ReactDOM.render(<LeagueTableWidget
            standings = { store.getState().standings}
            currentLeague={719}
            gamesStage={store.getState().currentGamesStage}
            regularSeasonEnd={store.getState().regularSeasonEnd}
            regularSeasonEndLeumit={store.getState().regularSeasonEndLeumit}
            leumitDisclaimer={leumitDisclaimer}
            disclaimer={disclaimer}
            onlyLeague={719}
        />, document.getElementById('league-table-react-leumit'));
    }

    //Render Homepage compare
    if(document.getElementById('player-compare-homepage-react')) {
        //React Player Compare
        //TODO: Merge players and teams
        if(compareType == 'player') {
            ReactDOM.render(<PlayerCompareWidget
                scrollClassName="player-compare-stats-rows"
                stats = { store.getState().stats}
                players={store.getState().players}
                player1Id={store.getState().player1Id}
                player2Id={store.getState().player2Id}
                type={store.getState().compareType}
            />, document.getElementById('player-compare-homepage-react'));
        } else {
            //React Team Compare
            ReactDOM.render(<PlayerCompareWidget
                scrollClassName="player-compare-stats-rows"
                stats = { store.getState().stats}
                players={store.getState().teams}
                player1Id={store.getState().team1Id}
                player2Id={store.getState().team2Id}
                type={store.getState().compareType}
            />, document.getElementById('player-compare-homepage-react'));
        }
    }

    //Render player page compare
    if(document.getElementById('player-compare-playerpage-react')) {
        ReactDOM.render(<PlayerCompareWidget
            scrollClassName="stats-table-scroll-container"
            stats={store.getState().stats}
            players={store.getState().players}
            player1Id={store.getState().player1Id}
            player2Id={store.getState().player2Id} />, document.getElementById('player-compare-playerpage-react'));
    }

    //Render homepage games Regular Season
    if(!regularSeasonEnd) {
        if(document.getElementById('rounds-games-react')) {
            ReactDOM.render(<RoundGamesWidget
                rounds={store.getState().roundsRegular}
                currentRound={store.getState().currentGamesRound }
                gamesStage={store.getState().currentGamesStage} />, document.getElementById('rounds-games-react'));
        }

    } else {
        //Render homepage games
        if(document.getElementById('rounds-games-react-upper-playoff')) {
            ReactDOM.render(<RoundGamesWidget
                rounds={store.getState().roundsUpper}
                currentRound={store.getState().currentGamesRoundUpper}
                gamesStage={store.getState().currentGamesStage}
                isRelegationRound={false} />, document.getElementById('rounds-games-react-upper-playoff'));
        }

        //Render homepage games
        if(document.getElementById('rounds-games-react-lower-playoff')) {
            ReactDOM.render(<RoundGamesWidget
                rounds={store.getState().roundsLower}
                currentRound={store.getState().currentGamesRoundLower}
                gamesStage={store.getState().currentGamesStage}
                isRelegationRound={true}/>, document.getElementById('rounds-games-react-lower-playoff'));
        }
    }
    var i = 0;

    //Render homepage stats 1
    if(document.getElementById('homepage-stats0-react')) {
        for(i = 0; i < slideCat.length; i++ ) {
            if(document.getElementById('homepage-stats' + i + '-react')) {
                ReactDOM.render(<StatsWidget
                    stats={store.getState().stats}
                    loading={store.getState().loading}
                    category={slideCat[i]}
                    players={store.getState().players }
                    league="902"
                    season="26/27"
                    limit="5"
                    additionalClass=" no-padding " />, document.getElementById('homepage-stats' + i + '-react'));
            }
        }
    }

    //Team page stats
    if(document.getElementById('stats-team-page1-react')) {
        for(i = 0; i < categories.length; i++ ) {
            if(document.getElementById('stats-team-page' + (i+1) + '-react')) {
                ReactDOM.render(<StatsWidget
                    stats={store.getState().stats}
                    loading={store.getState().loading}
                    category={categories[i]}
                    players={store.getState().players }
                    league="902"
                    limit="5"
                    season="26/27"
                    additionalClass=" no-padding "
                    filter={teamFilter} />,
                    document.getElementById('stats-team-page' + (i+1) + '-react'));
            }
        }
    }

    //Stats page stats
    if(document.getElementById('stats-page-widget-react')) {
        ReactDOM.render(<StatsPageWidget
            loading={store.getState().loading}
            categories={ store.getState().categories }
            players={ store.getState().players }
            teams={ store.getState().teams }
            stats={ store.getState().stats }
            rounds={ store.getState().rounds }
            statsFilter={ store.getState().statsFilter }
            selectedRound= { store.getState().selectedRound }
            selectedStage={ store.getState().selectedStage}
            selectedSeason = { store.getState().selectedSeason }
            selectedLeague = { store.getState().selectedLeague }
            selectedType = { store.getState().selectedType }
            showMoreCount= { store.getState().showMoreCount } />, document.getElementById('stats-page-widget-react'));
    }

    if(document.getElementById('react-modal')) {
        ReactDOM.render(<Modal
            isOpen={store.getState().modal.isOpen}
            onAfterOpen={handleAfterOpenFunc}
            onRequestClose={handleRequestCloseFunc}
            closeTimeoutMS={0}
            style={customStyles}
            contentLabel="All Stats"
            portalClassName="ReactModalPortal"
            overlayClassName="ReactModal__Overlay"
            className="ReactModal__Content"
            bodyOpenClassName="ReactModal__Body--open"
            ariaHideApp={true}
            shouldCloseOnOverlayClick={true}
            role="dialog"
            /*
             Function that will be called to get the parent element that the modal will be attached to.
             */
            parentSelector={() => document.body} >
            <StatsWidget key={ "statsWidgetModal" }
                         type={store.getState().selectedType}
                         category={store.getState().modal.selectedCategory}
                         players={ store.getState().players }
                         stats={store.getState().stats}
                         loading={store.getState().loading}
                         teams={store.getState().teams}
                         round={store.getState().selectedRound}
                         selectedRound= { store.getState().selectedRound }
                         limit="500"
                         selectedSeason={store.getState().selectedSeason}
                         filter={store.getState().statsFilter}
                         additionalClass=" no-padding "
                         showAll="0"
                         inModal={true} />
        </Modal>, document.getElementById('react-modal'));
    }

};

/*
 Function that will be run when the modal is requested to be closed, prior to actually closing.
 */
function handleRequestCloseFunc() {

}
/*
 Function that will be run after the modal has opened.
 */
function handleAfterOpenFunc() {

}

const store = createStore(reduce);
store.subscribe(render);
render();

if(isset(teamId) && teamId != null && isNumeric(teamId)){
    store.dispatch({type: 'SELECT_TEAM', val: parseInt(teamId) });
}

let teamApiFilter = {};

let gamesExpand = ["homeTeamId", "awayTeamId", "stadiumId", "homeScore", "awayScore", "date"];
let gamesFilter = {'league': currentLeague, 'season': currentSeason};

let statsExpand=["playerInstatId", "teamInstatId"];

if(document.getElementById('roundContainer')) {
    getFromBamboo(setRounds, 'round', {"seasonName": "26/27"}, null, false, "football", false, false, false);

    setInterval(function(args) {
        getFromBamboo(setRounds, 'round', {"seasonName": "26/27"}, null,false, "football", null, false, false);
    },60000);
}

switch(currentSitePage) {
    case 'team':
        getFromBamboo(setPlayers, 'player', null, null, "false", 'football', ['instatId', 'teamInstatId'], true); //Get basic stats players
        getFromBamboo(getStats, 'stats', store.getState().statsApiFilter, null, "false", 'football', statsExpand, true);
        getFromBamboo(setTeams, 'team', teamApiFilter, null, "false", 'football', ['instatId'], true);
        break;
    case 'player':
        getFromBamboo(getStats, 'stats', store.getState().statsApiFilter, null, "false", 'football', statsExpand, true);
        getFromBamboo(setPlayers, 'player', null, null, "true", 'football', ['instatId', 'teamInstatId']);
        break;
    case 'table':
        //call standings once and in interval
        getFromBamboo(setStandings, 'standings', store.getState().standingsApiFilter, null, true, "football", null,true, false);
        getFromBamboo(setTeams, 'team', teamApiFilter, null, "false", 'football', ['instatId']);

        //Every min update standing and games
        setInterval(function(args) {
            getFromBamboo(setStandings, 'standings', store.getState().standingsApiFilter, null, true, "football", null,true, false);
        },60000);
        break;
    case 'home':
        getFromBamboo(getStats, 'stats', store.getState().statsApiFilter, null, "false", 'football', statsExpand, true, false);
        getFromBamboo(setPlayers, 'player', null, null, "false", "football", ['instatId', 'teamInstatId']);

        //call rounds once and in interval

        getFromBamboo(setTeams, 'team', teamApiFilter, null, "false", 'football', ['instatId']);
        getFromBamboo(setGames, 'game', null, null, true, "football", gamesExpand);
        //call standings once and in interval
        getFromBamboo(setStandings, 'standings', store.getState().standingsApiFilter, null, true, "football", null,true, false);

        //Every min update standing and games
        setInterval(function(args) {
            getFromBamboo(setStandings, 'standings', store.getState().standingsApiFilter, null, true, "football", null,true, false);
            getFromBamboo(setGames, 'game', null, null, true, "football", gamesExpand, false, false)
        },60000);
        break;
    case 'stats':
        getFromBamboo(setStandings, 'standings', store.getState().standingsApiFilter, null, true, "football", null,true, false);
        getFromBamboo(setPlayers, 'player', null, null, "false", 'football', ['instatId', 'teamInstatId'], true); //Get basic stats players
        getFromBamboo(setTeams, 'team', teamApiFilter, null, "false", 'football', ['instatId'], true);
        // getFromBamboo(setRoundsStats, 'round', null, null, "false", "football", false, true, false);
        // getFromBamboo(getStats, 'stats', store.getState().statsApiFilter, null, "false", 'football', null, true, false);
        getFromBamboo(getStats, 'stats', {'tournamentId': parseInt(statsLeague), 'seasonName': "26/27", 'round': parseInt(selectedRound)}, null, "false", 'football', statsExpand, true, false);
        break;
    case 13: //page leumit
    case "13": //page leumit
    case "roni": //page leumit
        getFromBamboo(setStandings, 'standings', store.getState().standingsApiFilter, null, true, "football", null,true, false);
        getFromBamboo(setTeams, 'team', teamApiFilter, null, "false", 'football', ['instatId'], true);
        break;
    default:
}

function getStats(data) {
    store.dispatch({type: "SET_STATS", val: data});
    store.dispatch({type: "GOT_FULL_STATS", val: true});
    dataIsReady();
}

function setStandings(data) {
    store.dispatch({type: "SET_STANDINGS", val: data});
}

function dataIsReady(){
    let players = store.getState().players;
    let teams = store.getState().teams;
    let stats = store.getState().stats;
    if(typeof  players != 'undefined' && Object.keys(players).length &&
        typeof  teams != 'undefined' && Object.keys(teams).length &&
        typeof  stats != 'undefined' && stats != null ){
        store.dispatch({type: "STATS_LOADING", val: false});
    }
}

export { store };
